import { WindowProperty, getWindowValue } from "../../utils/window.utils";

export const getClientId = (): string =>
    getWindowValue(`${WindowProperty.IHUB_STATE}.tadaContext.clientId`);
export const getCustomerId = (): string =>
    getWindowValue(`${WindowProperty.IHUB_STATE}.tadaContext.customerId`);

export const generateAdditionalHeaders = ({
    stage,
    username,
}: {
    stage: string;
    username: string;
}): Record<string, string> => ({
    ...(["dev", "alpha"].includes(stage) && {
        "x-amz-request-csrf-token": "true",
    }),
    isInternal: "true",
    customerId: getCustomerId(),
    userAlias: username,
    "Amazon-Advertising-API-Scope": "",
    Accept: "",
});

export type HTTP_METHOD = "GET" | "PUT" | "POST" | "PATCH" | "DELETE";

export type AdvertisingApiClientRequest = {
    method: HTTP_METHOD;
    path: string;
    data?: any;
    additionalHeaders?: Record<string, string>;
    additionalRequestParams?: Record<string, any>;
    retryStatusCodes?: number[];
    retryPreHook?: VoidFunction;
};

export interface AdsApiGetParams {
    path: string;
    searchParams?: URLSearchParams;
}

export interface AdsApiPostParams {
    path: string;
    searchParams?: URLSearchParams;
    body: any;
}
